"use client";
import { useRef } from "react";
import { X } from "lucide-react";

export function MapSearch({ setSearchWord, searchWord }) {
  const inputRef = useRef(null);

  return (
    <div
      className="flex relative w-full animate-section-in"
      style={{
        // Match competitions / collection search: red gum button
        "--button-background": "137 33 2",
        "--button-hover-background": "137 33 2",
        "--button-foreground": "255 255 255",
      }}
    >
      <input
        ref={inputRef}
        id="filter-search"
        className="h-11 w-full rounded-l-full border-2 border-brand-fawn bg-white pl-3 pr-6 text-base focus:outline-none lg:w-[300px]"
        onChange={(e) => setSearchWord(e.target.value)}
        value={searchWord}
        placeholder="Search..."
        type="text"
      />
      {searchWord?.length > 0 && (
        <button
          className="absolute top-0 bottom-0 cursor-pointer right-24"
          type="button"
          onClick={() => {
            setSearchWord("");
            inputRef.current?.focus();
          }}
        >
          <X size={18} />
        </button>
      )}
      <button
        className="px-4 text-base font-button font-semibold rounded-r-full h-11 bg-button text-button-foreground"
        type="button"
      >
        Search
      </button>
    </div>
  );
}
